import * as React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { OptionProps, OptionTypeBase } from "react-select";
import OptimizedOption from "../../../../components/selector/optimized-option";

export interface ComparabilityOptionData extends OptionTypeBase {
  disabledReason?: string;
}

/**
 * Thin wrapper around `OptimizedOption` (the `Selector`-injected, react-window-virtualized option
 * renderer) that adds an `OverlayTrigger`/`Tooltip` when the option is disabled for a comparability
 * reason. Delegates all other rendering to `OptimizedOption` unchanged, rather than duplicating its
 * `onMouseMove`/`onMouseOver` deletion workaround, so `Selector`'s virtualization keeps working when
 * this component is passed as `components={{ Option: ComparableOption, MenuList: OptimizedMenuList }}`.
 */
const ComparableOption: React.FC<OptionProps<ComparabilityOptionData, false>> = props => {
  if (props.isDisabled && props.data.disabledReason) {
    return (
      <OverlayTrigger
        placement="right"
        overlay={
          <Tooltip id={`disabled-reason-${props.data.value}`}>{props.data.disabledReason}</Tooltip>
        }>
        {/* react-select's disabled options don't receive pointer events by default; a wrapping
            span restores hover/focus for the tooltip without altering react-select's own disabled
            styling/behavior, applied via OptimizedOption below. */}
        <span>
          <OptimizedOption {...props} />
        </span>
      </OverlayTrigger>
    );
  }
  return <OptimizedOption {...props} />;
};

export default ComparableOption;
